import {Component, ElementRef, Input} from '@angular/core';
import {MatDialog, PageEvent} from "@angular/material";
import {kanUsersService} from "../../../../services/services/users";
import {User} from "../../../../../classes/user";
import {Dog} from "../../../../../classes/dog";
import {kanDogsService} from "../../../../services/services/dogs";
import {ServiceLog} from "../../../../../classes/serviceLog";
import {kanServicesService} from "../../../../services/services/services";
import {kanServiceLogDialog} from "../../../dialogs/service-log-dialog/component";
import {Service} from "../../../../../classes/service";
import {kanAuthService} from "../../../../services/services/auth";

@Component({
    selector: 'kan-service-logs',
    templateUrl: './component.html',
    styleUrls: ['./component.scss']
})
export class kanSreviceLogs {

    @Input() selectedTab: number;
    @Input() tabNumber: number = 0;
    @Input() userId: string;
    @Input() dogId: string;
    public loading: boolean = false;
    public logs: ServiceLog[] = [];
    private users: User[] = [];
    private dogs: Dog[] = [];
    public search: string = '';
    public fromDate: Date;
    public toDate: Date;
    public services: Service[];
    public serviceId: string = null;
    public pageIndex: number = 0;
    public pageSize: number = 20;
    public totalLogs: number = 0;
    public filter: any = {
        where: {},
        include: ['user', 'dog'],
        order: 'start ASC',
        skip: 0,
        limit: 20
    };
    public timeout: any;

    constructor(private element: ElementRef,
                private dialog: MatDialog,
                private authService: kanAuthService,
                private servicesService: kanServicesService,
                private usersService: kanUsersService,
                private dogsService: kanDogsService) {
    }

    ngOnInit(): void {
        this.filter = {
            where: {},
            include: ['user', 'dog', 'service'],
            order: 'start ASC',
            skip: 0,
            limit: 20
        };

        if (this.userId && !this.dogId) {
            this.filter.where = {
                and: [
                    {
                        userId: this.userId
                    }
                ]
            };
        } else if (!this.userId && this.dogId) {
            this.filter.where = {
                and: [
                    {
                        dogId: this.dogId
                    }
                ]
            };
        } else if (this.userId && this.dogId) {
            this.filter.where = {
                and: [
                    {
                        userId: this.userId,
                        dogId: this.dogId
                    }
                ]
            };
        }
    }

    ngOnChanges(changes): void {
        if (changes.selectedTab.currentValue === this.tabNumber) {
            this.getLogs();
            this.getUsers();
            this.getDogs();
            this.getServices();
        }
    }

    get role(): string {
        return this.authService.role;
    }

    public getLogs(): void {

        this.loading = true;
        this.servicesService.countLogs(this.filter.where)
            .then((count) => {
                this.totalLogs = count;
                return this.servicesService.getLogs(this.filter);
            })
            .then((logs) => {
                this.logs = logs;
                this.loading = false;
                this.element.nativeElement.querySelector('.kan-service-logs-container').scrollTop = 0;
            })
            .catch((error) => {
                console.log(error);
                this.loading = false;
            });
    }

    public getUsers() {
        this.usersService
            .getUsers({
                where: {
                    role: 'USER',
                    active: true
                }
            })
            .then((users: User[]) => {
                this.users = users;
            })
            .catch((error: any) => {
                this.users = [];
                console.log(error);
            });
    }

    public getDogs() {
        this.dogsService
            .getDogs({
                where: {
                    active: true
                }
            })
            .then((dogs: Dog[]) => {
                this.dogs = dogs;
            })
            .catch((error: any) => {
                this.dogs = [];
                console.log(error);
            });
    }

    public getServices() {
        this.servicesService.getServices({})
            .then((services) => {
                this.services = services;
            })
            .catch((error: any) => {
                this.services = [];
                console.log(error);
            });
    }

    public add() {
        let dialogRef = this.dialog.open(kanServiceLogDialog, {
            data: {
                userId: this.userId,
                dogId: this.dogId
            },
            disableClose: true,
            width: '100%',
            maxWidth: '100%',
            height: '100%',
            maxHeight: '100%'
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result === 'add') {
                this.getLogs();
            }
        });
    }

    public changeDates(event) {
        console.log(this.fromDate);
        console.log(this.toDate);
    }

    public changePage(event: PageEvent) {

        this.pageIndex = event.pageIndex;
        this.pageSize = event.pageSize;
        this.filter.skip = this.pageIndex * this.pageSize;
        this.filter.limit = this.pageSize;
        this.getLogs();
    }

    private getUsersIds() {
        if (!this.userId) {
            return this.users
                .filter((user) => {
                    let arr = (this.search || '').split(' ');
                    let found = true;
                    arr.forEach((item) => {
                        if (item) {
                            found = found &&
                                (user.name.toLowerCase().includes(item.toLowerCase()) ||
                                    (user.surname ? user.surname.toLowerCase().includes(item.toLowerCase()) : false));
                        }
                    });
                    return found;
                })
                .map((user) => {
                    return user.id;
                });
        } else {
            return []
        }
    }

    private getDogsIds() {
        if (!this.dogId && !this.userId) {
            return this.dogs
                .filter((dog) => {
                    let arr = (this.search || '').split(' ');
                    let found = true;
                    arr.forEach((item) => {
                        if (item) {
                            found = found && (dog.name.toLowerCase().includes(item.toLowerCase()));
                        }
                    });
                    return found;
                })
                .map((dog) => {
                    return dog.id;
                });
        } else {
            return [];
        }
    }

    public setFilter() {
        clearTimeout(this.timeout);
        this.loading = true;
        this.pageIndex = 0;
        this.filter.skip = this.pageIndex * this.pageSize;
        this.filter.limit = this.pageSize;
        this.filter.where = {};

        let userIds = this.getUsersIds();
        let dogIds = this.getDogsIds();

        if (this.userId && !this.dogId) {
            this.filter.where = {
                and: [
                    {
                        userId: this.userId
                    }
                ]
            };
        } else if (!this.userId && this.dogId) {
            this.filter.where = {
                and: [
                    {
                        dogId: this.dogId
                    }
                ]
            };
        } else if (this.userId && this.dogId) {
            this.filter.where = {
                and: [
                    {
                        userId: this.userId,
                        dogId: this.dogId
                    }
                ]
            };
        }

        if (this.search.trim()) {

            if (!this.filter.where.and) {
                this.filter.where.and = [];
            }

            let fields = ['notes'];
            this.search.trim().split(/\s+/)
                .forEach((s) => {
                    let andBlock = {
                        or: []
                    };
                    s = s.replace(/[aäàá]/g, '[aäàá]')
                        .replace(/[eëéè]/g, '[eëéè]')
                        .replace(/[iïíì]/g, '[iïíì]')
                        .replace(/[oöóò]/g, '[oöóò]')
                        .replace(/[uüúù]/g, '[uüúù]')
                        .replace(/\./g, '\\.');
                    fields.forEach((field) => {
                        let orBlock = {};
                        orBlock[field] = {
                            like: `.*${s}.*`,
                            options: 'i'
                        };
                        andBlock.or.push(orBlock);
                    });

                    if (userIds.length) {
                        andBlock.or.push({
                            userId: {inq: userIds}
                        });
                    }

                    if (dogIds.length) {
                        andBlock.or.push({
                            dogId: {inq: dogIds}
                        });
                    }

                    this.filter.where.and.push(andBlock);
                });
        }

        if (this.fromDate) {
            if (!this.filter.where.and) {
                this.filter.where.and = [];
            }

            this.filter.where.and.push({
                start: {
                    gt: this.fromDate
                }
            });
        }

        if (this.toDate) {
            if (!this.filter.where.and) {
                this.filter.where.and = [];
            }

            this.filter.where.and.push({
                start: {
                    lt: this.toDate
                }
            });
        }

        if (this.serviceId) {
            if (!this.filter.where.and) {
                this.filter.where.and = [];
            }

            this.filter.where.and.push({
                serviceId: this.serviceId
            });
        }

        this.timeout = setTimeout(() => {
            this.getLogs();
        }, 800);
    }
}



// WEBPACK FOOTER //
// ./src/modules/admin/components/service-logs/service-logs/component.ts